const n = {
  name: "WarningDiamondFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.87838 1.70705C11.05 0.535475 12.9494 0.535477 14.121 1.70705L22.2926 9.87862C23.4642 11.0502 23.4642 12.9497 22.2926 14.1213L14.121 22.2928C12.9494 23.4644 11.05 23.4644 9.87838 22.2928L1.7068 14.1213C0.535231 12.9497 0.535233 11.0502 1.70681 9.87862L9.87838 1.70705ZM12.9997 5.99994H10.9997V11.9999H12.9997V5.99994ZM13.4997 15.4999C13.4997 14.6715 12.8281 13.9999 11.9997 13.9999C11.1713 13.9999 10.4997 14.6715 10.4997 15.4999C10.4997 16.3284 11.1713 16.9999 11.9997 16.9999C12.8281 16.9999 13.4997 16.3284 13.4997 15.4999Z" fill="currentColor"/>
</svg>
  `
};
export {
  n as WarningDiamondFilled
};
